/*
 * @Author: hai.zhang
 * @LastEditors: Please set LastEditors
 * @Date: 2019-08-19 10:12:38
 * @LastEditTime: 2022-01-10 19:47:50
 */
export default {
  field: [
    // 采购商城 - 我的商城
    {
      path: '/portal',
      name: 'portal',
      component: () => import(/* webpackChunkName: "portal" */'../routes/portal/index.vue'),
      meta: {
        title: {
          'zh-CN': '我的商城',
          en: '我的商城_en',
          jp: '我的商城_jp'
        },
        spmB: 'b18'
      }
    }
  ]
}
